import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS,  } from '@angular/common/http';
import { TokenInterceptor } from './interceptors/token.interceptor';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { TruncatePipe } from './pipes/truncate.pipe';
import { CurrencyFormatPipe } from './pipes/currency-format.pipe';
import { RelativeDatePipe } from './pipes/relative-date.pipe';
import { EnumToArrayPipe } from './pipes/enum-to-array.pipe';
import { StatusBadgePipe } from './pipes/status-badge.pipe';
import { SafePipe } from './pipes/safe.pipe';
import { HighlightPipe } from './pipes/highlight.pipe';
import { RemoveUnderscorePipe } from './pipes/remove-underscore.pipe';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { AutofocusDirective } from './directives/autofocus.directive';
import { ClickOutsideDirective } from './directives/click-outside.directive';
import { HasPermissionDirective } from './directives/has-permission.directive';
import { TooltipSimpleDirective } from './directives/tooltip-simple.directive';
import { KeyboardNavigationDirective } from './directives/keyboard-navigation.directive';


const pipes = [
  TruncatePipe,
  CurrencyFormatPipe,
  RelativeDatePipe,
  EnumToArrayPipe,
  StatusBadgePipe,
  SafePipe,
  HighlightPipe,
  RemoveUnderscorePipe
];

const directives = [
  OnlyNumberDirective,
  AutofocusDirective,
  ClickOutsideDirective,
  HasPermissionDirective,
  TooltipSimpleDirective,
  KeyboardNavigationDirective
];


@NgModule({
  declarations: [
    ...pipes,
    ...directives
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ...pipes,
    ...directives
  ],
   providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ]
})
export class CoreModule { }
